<template>
  <header
    v-scroll="handleSroll"
    v-resize="handleResizeMenu"
    class="navbar navbar-default navbar-fixed menu-top"
    :class="{ 'menu-shrink': menuShrink }"
  >
    <div class="app-container">
      <div class="content">
        <div class="logo">
          <img
            v-if="menuShrink"
            src="./../../../assets/logo_ddc.svg"
            alt="logo ddc.by"
          />
          <img
            v-else
            src="./../../../assets/logo_ddc_white.svg"
            alt="logo ddc.by"
          />
        </div>

        <div class="navigation-panel">
          <app-menu v-if="!mobile" :dark="menuShrink" />

          <language :dark="!menuShrink"></language>

          <settings :dark="!menuShrink"></settings>

          <menu-button
            v-if="mobile"
            :dark="!menuShrink"
            @click="openSidebar"
          ></menu-button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { Scroll } from '@/directive/scroll';
import { Resize } from '@/directive/resize';

import AppMenu from './components/Menu.vue';
import MenuButton from './components/MenuButton.vue';
import Settings from './Settings';
import Language from './Language';

export default {
  name: 'Navbar',
  components: {
    AppMenu,
    MenuButton,
    Settings,
    Language,
  },
  directives: {
    Scroll,
    Resize,
  },
  data: () => ({
    menuShrink: false,
  }),
  computed: {
    ...mapState('app', ['mobile', 'sidebar']),
  },
  methods: {
    ...mapActions('app', ['openSidebar', 'hasMobileDevice']),
    handleSroll() {
      this.menuShrink = window.scrollY > 50;
    },
    handleResizeMenu() {
      this.hasMobileDevice(window.innerWidth < 910);
    },
  },
};
</script>

<style lang="stylus" scoped>
.navbar {
  position: relative;
  min-height: 50px;
  z-index: 1000;

  &.navbar-default {
    width: 100%;
    padding: 10px 0;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;

      .navigation-panel {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }

  &.navbar-fixed {
    position: fixed;
    right: 0;
    left: 0;
  }

  &.menu-top {
    themify(
      $themes,
      @($theme) {
      background: $theme.$navbar--background--color;
    }
    );
  }
}

.navbar-default.menu-shrink {
  themify(
    $themes,
    @($theme) {
    background-color: $theme.$navbar--background--color--scroll;
  }
  );
  box-shadow: 0px 5px 10px rgba(20, 97, 255, 0.1);
}

.logo {
  display: flex;
  height: 40px;
}
</style>
